import request from '@/utils/request'

/**
 * 获取登录后地区上下文（IP -> 地区/语言/支付方式）
 */
export const getRegionContext = (options = {}) => {
  const headers = {}
  if (options.debugRegion) {
    headers['X-Debug-Region'] = options.debugRegion
  }
  return request({
    url: '/client/common/regionContext',
    method: 'POST',
    headers
  })
}
